import { render, staticRenderFns } from "./PracticeModal.vue?vue&type=template&id=0c1bf328&"
import script from "./PracticeModal.vue?vue&type=script&lang=js&"
export * from "./PracticeModal.vue?vue&type=script&lang=js&"
import style0 from "./PracticeModal.vue?vue&type=style&index=0&id=0c1bf328&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports